import React from "react"
import { Field, ErrorMessage, getIn } from "formik"
import ErrorPopUp from '../../Shared/ErrorPopUp'
import { AsyncCategorySelect } from '../../Shared/AsyncCategorySelect'
import AsyncBrandSelect from '../../Shared/AsyncBrandSelect'
import AsyncProductSelect from '../../Shared/AsyncProductSelect'
import NumberFormat from 'react-number-format'
import measurementTypes from '../../../_constants/measurementTypes'


export default ({ touched, errors, setFieldValue, values, handleBlur, taskType }) => (
  <div className="row display-flex">
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">

      <fieldset className="fieldset">
        <legend>اطلاعات کالا جهت تولید</legend>

        <table className="table validator-table" style={{ marginBottom: 5 }}>
          <thead>
            <tr>
              <th className="text-center">ردیف</th>
              <th className="text-center">دسته بندی</th>
              <th className="text-center">برند</th>
              <th className="text-center">نام کالا</th>
              <th className="text-center">کد کالا</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>
                {values.product && values.product && values.product.category.name}
              </td>
              <td>
                {values.product && values.product && values.product.brand.name}
              </td>
              <td>
                {values.product && values.product && values.product.name}
              </td>
              <td>
                {values.product && values.product && values.product.extraCode}
              </td>
            </tr>
          </tbody>
        </table>

      </fieldset>

    </div>

  </div>
);